module.exports = __webpack_public_path__ + "img/rec-07.b2e88448.png";